import { FastField } from 'formik';
import { QuestionProps, buildFormKey } from '.';
import { CerebroLabel, CerebroTextarea } from '../../shared/components';

export const DealQuestionOpenEnded: React.FC<QuestionProps> = ({ question, isSubmitting }) => {
	const textKey = buildFormKey(question, 'text');

	return (
		<>
			<CerebroLabel htmlFor={textKey}>{question.questionText}</CerebroLabel>
			<FastField
				id={textKey}
				name={textKey}
				as={CerebroTextarea}
				sx={{ marginLeft: 2 }}
				disabled={isSubmitting}
			/>
		</>
	);
};
